<div style="overflow: auto; height: calc(100vh - 220px)">
    <p class="text-muted small mt-2">{{ exclusionNote }}</p>

    <h5>Biggest price changes</h5>
    <p class="text-muted small">{{ changeNote }}</p>
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <action-toolbar-count [grid]="changeGrid"></action-toolbar-count>
                <grid-export [grid]="gridPriceChanges" [name]="'Purchased Material Price Changes'"></grid-export>
            </form>
        </div>
    </div>
    <grid-column-group [grid]="changeGrid"></grid-column-group>
    <wj-flex-grid
        id="gridPriceChanges"
        #gridPriceChanges
        style="height: 280px"
        [isReadOnly]="true"
        (initialized)="changeGrid.initialize(gridPriceChanges)"
        (destroy)="changeGrid.destroy()"
        [itemsSource]="changeGrid.view"
    >
        <wj-flex-grid-filter></wj-flex-grid-filter>
        <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="420" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Category'" [binding]="'category'" [width]="120" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Unit'" [binding]="'unitFamily'" [width]="90" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Start lines'" [binding]="'startLines'" [width]="110" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Start median'" [binding]="'startMedian'" [width]="130" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'End lines'" [binding]="'endLines'" [width]="110" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'End median'" [binding]="'endMedian'" [width]="130" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Change %'" [binding]="'percentChange'" [width]="110" [format]="'n1'" [isReadOnly]="true"></wj-flex-grid-column>
    </wj-flex-grid>
    <grid-selection-calculation [grid]="gridPriceChanges"></grid-selection-calculation>

    <h5 class="mt-3">Category price index</h5>
    <p class="text-muted small">{{ indexNote }}</p>
    @if (indexChart.series.length) {
        <wj-flex-chart
            [itemsSource]="indexChart.points"
            [bindingX]="'label'"
            [chartType]="'Line'"
            [header]="'Category price index'"
            [legendToggle]="true"
            style="height: 320px"
        >
            <wj-flex-chart-legend [position]="'Bottom'"></wj-flex-chart-legend>
            <wj-flex-chart-axis [wjProperty]="'axisY'" [title]="'Index'" [format]="'n1'"></wj-flex-chart-axis>
            @for (series of indexChart.series; track series.binding) {
                <wj-flex-chart-series [binding]="series.binding" [name]="series.name"></wj-flex-chart-series>
            }
        </wj-flex-chart>
    }
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <action-toolbar-count [grid]="indexGrid"></action-toolbar-count>
                <grid-export [grid]="gridPriceIndex" [name]="'Purchased Material Price Index'"></grid-export>
            </form>
        </div>
    </div>
    <grid-column-group [grid]="indexGrid"></grid-column-group>
    <wj-flex-grid
        id="gridPriceIndex"
        #gridPriceIndex
        style="height: 220px"
        [isReadOnly]="true"
        (initialized)="indexGrid.initialize(gridPriceIndex)"
        (destroy)="indexGrid.destroy()"
        [itemsSource]="indexGrid.view"
    >
        <wj-flex-grid-filter></wj-flex-grid-filter>
        <wj-flex-grid-column [header]="'Category'" [binding]="'category'" [width]="140" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Month'" [binding]="'month'" [width]="110" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Index'" [binding]="'index'" [width]="100" [format]="'n1'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Items'" [binding]="'itemCount'" [width]="90" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
    </wj-flex-grid>

    <h5 class="mt-3">Item price history</h5>
    <p class="text-muted small">
        Find lists descriptions in the selected dates and category. Select one to see its monthly median price.
    </p>
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline" style="align-items: center">
                <input
                    class="form-control"
                    style="width: 360px"
                    name="priceSearch"
                    [(ngModel)]="finderText"
                    (keyup.enter)="findDescriptions()"
                    placeholder="Description contains"
                />
                <button type="button" class="btn btn-sm btn-primary" (click)="findDescriptions()">Find</button>
                <button type="button" class="btn btn-sm btn-primary" [disabled]="!suggestionGrid.selectedItem" (click)="showSuggestion()">
                    Price history
                </button>
                <label class="mb-0" style="display: flex; align-items: center; gap: 6px">
                    <input type="checkbox" name="byVendor" [(ngModel)]="byVendor" (ngModelChange)="showHistory()" />
                    One line per vendor
                </label>
            </form>
        </div>
    </div>
    <wj-flex-grid
        id="gridPriceSuggestions"
        #gridPriceSuggestions
        style="height: 220px"
        [isReadOnly]="true"
        (initialized)="suggestionGrid.initialize(gridPriceSuggestions)"
        (destroy)="suggestionGrid.destroy()"
        (dblclick)="showSuggestion()"
        [itemsSource]="suggestionGrid.view"
    >
        <wj-flex-grid-filter></wj-flex-grid-filter>
        <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="520" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Lines'" [binding]="'lineCount'" [width]="90" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
    </wj-flex-grid>
    @if (chosen()) {
        <p class="mt-3">
            Showing <strong>{{ chosen() }}</strong>
        </p>
        <p class="text-muted small">{{ historyNote }}</p>
        @if (vendorChartIsCapped()) {
            <p class="text-muted small">The chart shows the 8 vendors with the most lines. The grid lists every vendor.</p>
        }
        @if (historyChart.series.length) {
            <wj-flex-chart
                [itemsSource]="historyChart.points"
                [bindingX]="'label'"
                [chartType]="'Line'"
                [header]="'Median unit price'"
                [legendToggle]="true"
                style="height: 320px"
            >
                <wj-flex-chart-legend [position]="'Bottom'"></wj-flex-chart-legend>
                <wj-flex-chart-axis [wjProperty]="'axisY'" [title]="'Median unit price'" [format]="'c2'"></wj-flex-chart-axis>
                @for (series of historyChart.series; track series.binding) {
                    <wj-flex-chart-series [binding]="series.binding" [name]="series.name"></wj-flex-chart-series>
                }
            </wj-flex-chart>
        }
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="historyGrid"></action-toolbar-count>
                    <grid-export [grid]="gridPriceHistory" [name]="'Purchased Material Price History'"></grid-export>
                </form>
            </div>
        </div>
        <grid-column-group [grid]="historyGrid"></grid-column-group>
        <wj-flex-grid
            id="gridPriceHistory"
            #gridPriceHistory
            style="height: 280px"
            [isReadOnly]="true"
            (initialized)="historyGrid.initialize(gridPriceHistory)"
            (destroy)="historyGrid.destroy()"
            [itemsSource]="historyGrid.view"
        >
            <wj-flex-grid-filter></wj-flex-grid-filter>
            <wj-flex-grid-column [header]="'Month'" [binding]="'month'" [width]="110" [isReadOnly]="true"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Unit'" [binding]="'unitFamily'" [width]="90" [isReadOnly]="true"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Vendor'" [binding]="'vendor'" [width]="220" [isReadOnly]="true"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Lines'" [binding]="'lineCount'" [width]="90" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Median'" [binding]="'median'" [width]="120" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Min'" [binding]="'min'" [width]="120" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Max'" [binding]="'max'" [width]="120" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Vendors'" [binding]="'vendorCount'" [width]="100" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
        </wj-flex-grid>
        <grid-selection-calculation [grid]="gridPriceHistory"></grid-selection-calculation>
    }
</div>
